import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import MedAmountForm from './MedAmountForm';

const EditMedAmountModal = ({ show, onHide, medamtvalue, edittrigger, onCallParent }) => {
    const isEdit = medamtvalue && (medamtvalue.amount_id || medamtvalue.id);

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Amount' : 'Add Amount'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <MedAmountForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    medamtvalue={medamtvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

EditMedAmountModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    medamtvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default EditMedAmountModal;
